import { DiscountsCartData, ProductCartData } from '../../interfaces/carts'

export const calculateProductsTotalPrice = (products: ProductCartData[]): number =>
  products.reduce((acc, product) => acc + product.totalPrice, 0)

export const calculateTotalDiscountsByProvider = (discounts: DiscountsCartData[], providerId: string) =>
  discounts.reduce((acc, discount) => (discount.providerId === providerId ? acc + Number(discount.amount) : acc), 0)
